'use client';

import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { Table as ShadcnTable, TableBody as ShadcnTableBody, TableCaption as ShadcnTableCaption, TableCell as ShadcnTableCell, TableFooter as ShadcnTableFooter, TableHead as ShadcnTableHead, TableHeader as ShadcnTableHeader, TableRow as ShadcnTableRow } from '@/components/ui/table';
import { cn } from '@/lib/ui/utils';
const TABLE_TYPOGRAPHY = 'text-body' as const;
export function Table(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn(TABLE_TYPOGRAPHY, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <ShadcnTable className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function TableHeader(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ShadcnTableHeader {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function TableBody(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ShadcnTableBody {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function TableFooter(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ShadcnTableFooter {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function TableRow(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ShadcnTableRow {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function TableHead(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ShadcnTableHead {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function TableCell(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ShadcnTableCell {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function TableCaption(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn(TABLE_TYPOGRAPHY, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <ShadcnTableCaption className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}